const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export interface FavoriteOrder {
  favorite_id: number;
  user_id: number;
  favorited_at: string;
  order_id: number;
  user_name: string;
  user_surname: string;
  management: string;
  office: string;
  total_amount: number;
  status: 'pending' | 'preparing' | 'on-the-way' | 'completed' | 'cancelled';
  ticket_used: number;
  order_created_at: string;
  order_updated_at: string;
  item_count: number;
  items: Array<{
    id: number;
    product_id: number;
    name: string;
    quantity: number;
    price: number;
    size?: string;
    strength?: string;
  }>;
}

export const favoriteService = {
  // Kullanıcının favori siparişlerini getir
  async getUserFavorites(userId: number): Promise<FavoriteOrder[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/favorites/user/${userId}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Favori siparişler getirme hatası:', error);
      throw new Error('Favori siparişler alınamadı');
    }
  },

  // Sipariş favorilere ekle
  async addToFavorites(
    userId: number,
    orderId: number
  ): Promise<{ success: boolean; message: string; alreadyExists?: boolean }> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/favorites`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, orderId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Favori ekleme hatası:', error);
      throw new Error(error instanceof Error ? error.message : 'Favori eklenemedi');
    }
  },

  // Sipariş favorilerden çıkar
  async removeFromFavorites(
    userId: number,
    orderId: number
  ): Promise<{ success: boolean; message: string }> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/favorites/${userId}/${orderId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Favori silme hatası:', error);
      throw new Error(error instanceof Error ? error.message : 'Favori silinemedi');
    }
  },

  // Kullanıcının favori sipariş ID'lerini getir
  async getFavoriteIds(userId: number): Promise<number[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/favorites/user/${userId}/ids`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Favori ID'leri getirme hatası:", error);
      throw new Error("Favori ID'leri alınamadı");
    }
  },
};
